export enum LegacyTeamMemberRole {
    OWNER = "owner",
    MEMBER = "member",
    MEMBER_LICENSED = "member-licensed",
    LIBRARIAN = "librarian"
}
